import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function FreiburgHero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4b3d55f34dda000e46252f07c9cb1ef8.jpg"
          alt="Webdesign Freiburg – BR Webdesign & AI Solutions"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 pt-32 pb-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/20 border border-brand-green/40 rounded-full mb-8 backdrop-blur-sm"
          >
            <i className="ri-map-pin-2-fill text-brand-green-light text-sm" />
            <span className="text-sm font-semibold text-white">Webdesign Freiburg im Breisgau</span>
          </motion.div>

          {/* H1 */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6"
          >
            Webdesign
            <br />
            <span className="text-brand-green-light">Freiburg</span>
            <br />
            das verkauft.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg md:text-xl text-white/85 mb-10 leading-relaxed max-w-2xl"
          >
            Professionelle Webseiten für Freiburger Unternehmen – mit{' '}
            <strong className="text-white">AI-Chatbots</strong>,{' '}
            <strong className="text-white">SEO-Optimierung</strong> und{' '}
            <strong className="text-white">Festpreis ab 899 €</strong>. Fertig in max. 1 Woche.
          </motion.p>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex flex-wrap gap-6 mb-10"
          >
            {[
              { value: '899 €', label: 'Festpreis' },
              { value: '1 Woche', label: 'Lieferzeit' },
              { value: '100 %', label: 'Zufriedenheit' },
            ].map(({ value, label }) => (
              <div key={label} className="flex flex-col">
                <span className="text-3xl font-bold text-brand-green-light">{value}</span>
                <span className="text-sm text-white/70">{label}</span>
              </div>
            ))}
          </motion.div>

          {/* CTAs */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <Link
              to="/webdesign-freiburg#kontakt"
              className="group inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-green-light text-white px-8 py-4 rounded-lg font-semibold text-base transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <span>Kostenloses Erstgespräch</span>
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href="tel:01623651571"
              className="inline-flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 text-white px-8 py-4 rounded-lg font-semibold text-base border border-white/30 transition-all backdrop-blur-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line" />
              0162 365 1571
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.6 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2"
      >
        <span className="text-white/50 text-xs tracking-widest uppercase">Mehr entdecken</span>
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          className="w-6 h-6 flex items-center justify-center"
        >
          <i className="ri-arrow-down-line text-white/50 text-xl" />
        </motion.div>
      </motion.div>
    </section>
  );
}
